import React, { useState } from 'react';
import { Typography, Container, Grid, Box, Card, CardContent, Stack, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tabs, Tab } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { AntTabs, AntTab } from '../tabs_style';
import logoinjupempblack from '../../../Components/image.png'
import html2pdf from 'html2pdf.js';

export default function FiniquitoROAnterior() {
  const [tabIndex, setTabIndex] = React.useState(7);
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const [rows, setRows] = useState([
    {
      id: 1,
      inicio: null,
      final: null,
      errors: {
        inicio: { fechaVacia: false, invalidFormat: false, cleared: false },
        final: { fechaVacia: false, invalidFormat: false, cleared: false }
      }
    }
  ]);

  const data = [
    { description: 'COTIZACIONES A FECHA DE R.O.', amount: 'L. 0.00' },
    { description: 'INTERESES A FECHA DE R.O.', amount: 'L. 0.00', msj: 'MÁS' },
    { description: 'MONTO DEL R.O.', amount: 'L. 0.00', msj: 'MENOS' },
    { description: 'COTIZACIONES DESPUÉS DEL R.O.', amount: 'L. 0.00', msj: 'MÁS' },
    { description: 'OTROS', amount: 'L. 0.00', msj: 'MÁS' },
    { description: 'REBAJAS', amount: 'L. 0.00', msj: "MENOS" },
    { description: 'INTERESES DESDE R.O. A FECHA DE SOLICITUD', amount: 'L. 0.00', msj: 'MÁS' },
    { description: 'TOTAL SEGÚN CÁLCULOS ANTERIORES AL 13/05/14', amount: '0.00' },
    { description: 'VALOR ACTUAL DE COTIZACIONES DESPUÉS DEL 13/05/14', amount: 'L. 0.00' },
    { description: 'FACTOR DE RESCATE', amount: 'L. 0.00', msj: 'POR' },
    { description: 'MONTO DE COTIZACIONES DESPUÉS DE APLICAR FACTOR DE RESCATE', amount: 'L. 0.00' },
    { description: 'TOTAL DEL BENEFICIO', amount: 'L. 0.00' },
  ];

  const handlePrint = () => {
    const element = document.getElementById('cardContent');
    const cardContent = element.cloneNode(true); // Clonamos el contenido del Card para no afectar la vista actual

    // Reducimos el tamaño de la letra y la tabla
    const styles = `
      #cardContent {
        font-size: 0.4em; /* Reducimos el tamaño de la letra */
      }
      #cardContent table {
        font-size: 0.3em; /* Reducimos el tamaño de la tabla */
      }
      #cardContent table th, #cardContent table td {
        padding: 1px; /* Reducimos el padding de las celdas de la tabla */
      }
      #cardContent table {
        width: 100%; /* Ajustamos el ancho de la tabla */
      }
      #cardContent >.MuiCard-root {
        border: none; /* Eliminamos el borde del Card */
      }
    `;
    const styleElement = document.createElement('style');
    styleElement.innerHTML = styles;
    cardContent.appendChild(styleElement);

    html2pdf()
      .set({
        margin: 0.1, // Ajustamos el margen del PDF
        filename: 'finiquito.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 5 }, // Ajustamos la escala del PDF
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
      })
      .from(cardContent)
      .toPdf()
      .get('pdf')
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          //pdf.setFontSize(4); // Reducimos el tamaño de la letra para mejor ajuste
        }
      })
      .save();
  };

  return (
    <>
      <Grid container direction="column" alignItems="center">
        <Container>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <h2>Finiquito Y Dictamen</h2>
          </div>
        </Container>
        <Container>
          <Box sx={{ position: 'sticky', top: 0, zIndex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Paper square>
              <AntTabs
                value={tabIndex}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{
                  style: { display: 'none' }, // O también puedes usar display: 'none' aquí
              }}
              >
                <AntTab label="Resumen" />
                <AntTab label="Tabla De Interés" />
                <AntTab label="Datos" />
                <AntTab label="Cálculos" />
                <AntTab label="Períodos" />
                <AntTab label="Rebajas" />
                <AntTab label="Comparativa Devolución 10%" />
                <AntTab label="Finiquito y Dictamen" />
              </AntTabs>
            </Paper>
          </Box>

          <Box mt={3}>
            {/* Contenido de la pestaña actual */}
            {tabIndex === 0 && navigate('Separaciones/ResumenROAnterior')}
            {tabIndex === 1 && navigate('Separaciones/TablaDeInteresROAnterior')}
            {tabIndex === 2 && navigate('/Separaciones/ROantes13demayo2014')}
            {tabIndex === 3 && navigate('/Separaciones/CalculosROAnterior')}
            {tabIndex === 4 && navigate('/Separaciones/PeriodosROAnterior')}
            {tabIndex === 5 && navigate('/Separaciones/RebajasROAnterior')}
            {tabIndex === 6 && navigate('/Separaciones/ComparativaROAnterior')}
            {tabIndex === 7}
          </Box>
        </Container>
      </Grid>

      <Container style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <h2 style={{ textAlign: 'center', fontSize: '1.5em' }}>CONSTANCIA DE RECIBO DE COTIZACIONES POR SEPARACIÓN DEL <br />
          SISTEMA CON APLICACIÓN DE OFICIO ANTES DEL 13 DE MAYO DEL 2014</h2>
      </Container>

      <Box marginTop={2} boxShadow={2} id="cardContent" sx={{ fontSize: '0.8em' }}>
        <Card variant='outlined'>
          <CardContent>
            <Stack direction="row" marginTop={1}>
              <Grid container spacing={1}>
                <Box display="flex" alignItems="center" width="100%">
                  <Typography>
                    <b>
                      MSc. Amable De Jesús Hernandez <br />
                      Director Interino <br />
                      INJUPEMP
                    </b>
                  </Typography>
                  <Box display="flex" justifyContent="flex-end" flex="1">
                    <img src={logoinjupempblack} alt="Logo INJUPEMP" style={{ maxWidth: '100px', maxHeight: '100px' }} />
                  </Box>
                </Box>
                <Typography marginTop={2} textAlign={'justify'}>
                  Yo _____________________________________ con con tarjeta de Identidad __________________________ por este medio declaro y hago constar que por virtud de
                  solicitud presentada al efecto, en esta fecha se me entrega de parte del Instituto Nacional de Jubilaciones y Pensiones de los Empleados y
                  Funcionarios del Poder Ejecutivo (INJUPEMP) la cantidad de: _________________ En concepto de COTIZACIONES INDIVIDUALES, efectuadas al sistema,
                  incluyendo sus respectivos intereses generados, y resultante de la liquidación practicada a la fecha de parte del Instituto, siendo sus cotizaciones:
                </Typography>
                <Box marginTop={2}>
                  <TableContainer>
                    <Table aria-label="cotizaciones table">
                      <TableHead>
                        <TableRow>
                          <TableCell style={{ fontSize: 20, textAlign: 'center', backgroundColor: 'lightgrey' }}></TableCell>
                          <TableCell style={{ fontSize: 20, textAlign: 'center', backgroundColor: 'lightgrey' }}><b>Descripción</b></TableCell>
                          <TableCell style={{ fontSize: 20, textAlign: 'center', backgroundColor: 'lightgrey' }}><b>Monto</b></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.map((row, index) => (
                          <TableRow key={row.description}>
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{
                                backgroundColor: index % 2 === 0 ? 'white' : '#eeeeee',
                                width: '10px',
                                textAlign: 'center'
                              }}
                            >
                              {row.msj}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{ backgroundColor: index % 2 === 0 ? 'white' : '#eeeeee', }}
                              width={800}
                            >
                              <b>{row.description}</b>
                            </TableCell>
                            <TableCell
                              style={{ textAlign: 'center' }}
                              sx={{ backgroundColor: index % 2 === 0 ? 'white' : 'lightgray' }}
                              width={800}
                            >
                              {row.amount}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography marginTop={2} textAlign={'justify'}>
                  Estoy entendiendo que con el retiro de mis cotizaciones quedo separado del sistema temporalmente, así como del goce y disfrute de los beneficios que el mismo concede a sus participantes.
                  Quedo así mismo entendido al tenor de lo dispuesto en el Artículo 74 de la Ley del Instituto que en caso de reingreso al servicio quedo obligado a reintegrar el valor actualizado financieramente
                  del monto del beneficio de separación correspondiente al participante, previo a la aplicación de las deducciones de obligaciones que hubieren tenido efecto. Dicha actualización financiera debe ser
                  establecida mediante la capitalización anual del monto del beneficio de  separación utilizando las tasas anuales de rentabilidad nominal ponderada por el instituto.
                  En fe de lo cual, para constancia y seguridad del INJUPEMP, firmo la presente en duplicado, quedando la original en el expediente administrativo, y copia para mi archivo.
                  En la ciudad de Tegucigalpa Municipio del Distrito Central a los ___ días del mes de _____ del año ____.
                </Typography>
                <Container style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                  <Typography marginTop={5} textAlign={'center'}>
                    ___________________________ <br /> Firma
                  </Typography>
                </Container>
              </Grid>
            </Stack>
          </CardContent>
        </Card>
      </Box>

      <Container style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: 20 }}>
        <Button
          variant="contained"
          startIcon={<PrintIcon style={{ fontSize: 40 }} />}
          size='large'
          style={{ width: '200px', height: '50px', backgroundColor: "#AD8401" }}
          onClick={handlePrint}
        >
          Imprimir
        </Button>
      </Container>
    </>
  );
}
